import type { CreateClientConfig } from '../generated/uis/client.gen';
import {
  createFetchWithTimeout,
  ENDPOINT_BOOKINGHUB_API,
  ENDPOINT_BOOKINGHUB_API_TIMEOUT,
} from '../utils';

const SLOW_ENDPOINTS = [
  '/booking-hub/test/cabinpresents',
  '/booking-hub/test/voucher',
  '/booking-hub/voucher',
  '/booking-hub/contest',
  '/booking-hub/presigned-url',
  '/booking-hub/test/contest',
  '/booking-hub/test/presigned-url',
];

export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  baseUrl: ENDPOINT_BOOKINGHUB_API,
  fetch: createFetchWithTimeout(request => {
    if (
      request.method === 'POST' &&
      SLOW_ENDPOINTS.some(slowEndpoint => request.url.includes(slowEndpoint))
    ) {
      // (Indirekte) Externe API, die der sehr langsam antwortet
      return 15_000;
    }
    return ENDPOINT_BOOKINGHUB_API_TIMEOUT;
  }),
});
